// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"modal_backdrop__dD-qH","modal":"modal_modal__2yhh3"};